export default "__VITE_ASSET__D_npJtbh__"